<app-toast></app-toast>
<app-confirmation-modal></app-confirmation-modal>
<update-billing-infos-popup *ngIf="showBillingPopup"></update-billing-infos-popup>

<router-outlet></router-outlet>
